/**
 * @file 操作指引侧边栏
 * @author edwardzhao, alfielv, malcolmmzma
 */

import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Checkbox, Loading } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

import globalStore from '@/stores';
import { hasFeatureFlag } from '@/services';
import { getUserCert, getUser } from '@/api/operator/cgi/agm';

import './index.less';

const STORAGE_KEY_FOR_TIPS_POP = 'REAL_NAME_SIDEBAR_TIP';
const SEVEN_DAYS = 7 * 24 * 3600 * 1000;

export default React.memo(observer((_props: any) => {
  // 七日内不再提醒 CheckBox
  const [ignore7Days, setIgnore7Days] = useState(false);
  // 是否展示TIPS
  const [showTips, setShowTips] = useState((!Boolean(sessionStorage.getItem(STORAGE_KEY_FOR_TIPS_POP)))
    && (new Date().getTime() - (Number(localStorage.getItem(STORAGE_KEY_FOR_TIPS_POP)) || 0) > SEVEN_DAYS));
  // 员工在所属公司下是否全部审核通过
  const [hasCert, setHasCert] = useState(true);
  // 是否实名认证过
  // const [hasRealNameVerify, setHasRealNameVerify] = useState<null | boolean>(null);

  const { user_id: userId, featureFlagInitDone, role_list: roleList = [], real_name_verify_status } = globalStore.account;
  const { pathname } = useLocation();
  const employeePage = useMemo(() => pathname === '/organization/employee', [pathname]);

  const onClose = useCallback(() => {
    setShowTips(false);
    if (ignore7Days) {
      localStorage.setItem(STORAGE_KEY_FOR_TIPS_POP, `${new Date().getTime()}`);
    }
    sessionStorage.setItem(STORAGE_KEY_FOR_TIPS_POP, 'true');
  }, [ignore7Days]);

  useEffect(() => {
    // getUser(userId).then((res) => {
    //   const { code, data } = res || {};
    //   if (code === 0) {
    //     setHasRealNameVerify(data?.real_name_verify_status === 1);
    //   }
    // });
    getUserCert(userId).then((res) => {
      const { code, data } = res || {};
      if (code === 0) {
        // 员工在所有所属公司下都审核通过
        setHasCert(_.every(data?.list, (item) => item?.approval_status === 1));
      }
    });
  }, []);

  // 由于最终的feature_flag_list由2个API的结果拼接而成，且其中一个API比较耗时（3-4s in test env），
  // 需依据featureFlagInitDone来判断是否已经初始化完成，避免在初始化完成前调用hasFeatureFlag方法而返回错误的结果
  if (!featureFlagInitDone) {
    return null;
  };

  // 【不再员工管理页】、【不是110, 117】或【在灰度范围内】，不展示
  const enableToShow = employeePage
    && Boolean(userId)
    && Boolean(globalStore.account?.role_list?.['100'] || globalStore.account?.role_list?.['117'])
    && Boolean(real_name_verify_status)
    && hasCert && !hasFeatureFlag('is_offline_batch_user_verify');

  return enableToShow ? (
    <div className='real-name-sidebar'>
      <div className='real-name-sidebar-card'>
        <div className='real-name-sidebar-title' onClick={(e) => window.open('https://docs.qq.com/doc/DRHVqSFlRbENkQmNl', '_blank')}>
          <Icon name='questionnaire-outlined' className='real-name-sidebar-icon' />
          操作指引
        </div>
        {
          showTips && <div className='real-name-sidebar_mask'>
            <div className='real-name-sidebar_pop'>
              <div>请根据操作指引完成员工实名认证</div>
              <div className='real-name-sidebar-footer'>
                <Button size='small' displayType='primary' onClick={onClose}>
                  我知道了
                </Button>
                <Checkbox
                  onChange={(_evt: any, value: boolean) => setIgnore7Days(!!value)}
                  value='1'
                  checked={!!ignore7Days}
                >七日内不再提醒</Checkbox>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  ) : null;
}));
